 <!-------------Benefits of Merchant Fold Start----------------->
 <div id="benefits-wellbux" data-aos="fade-up" class="benefits__of__merchant__fold" style="background-image: url(images/svg_icons/wave-bg.svg);">
    <div class="container">
      <h1>Benefits of Merchant</h1>
      <strong>Whether you are a corporate user or a wellbux user, you just need to participate in challenges to earn wellbux.</strong>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4" data-aos="fade-up">
          <div class="benefits__of__merchant__box">
            <h2>Can Participate in Special Sale</h2>
            <i><img src="/assets/images/svg_icons/paricipate-sale.svg" alt="icon" /></i>
            <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4" data-aos="fade-up">
          <div class="benefits__of__merchant__box">
            <h2>Can Create and publish different kinds of coupons</h2>
            <i><img src="/assets/images/svg_icons/publish-coupons.svg" alt="icon" /></i>
            <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>


        <div class="col-lg-4 col-md-4 col-sm-4" data-aos="fade-up">
          <div class="benefits__of__merchant__box">
            <h2>Can keep a track of sale through easy and interactive report system</h2>
            <i><img src="/assets/images/svg_icons/track.svg" alt="icon" /></i>
            <p>Duis varius lectus eget risus dapibus pharetra. Sed porttitor pulvinar blandit. Curabitur fringilla scelerisque nulla,</p>
          </div>
        </div>
      </div>
      <div class="benefits__merchant__btn">
        <a href="#">Become a Merchant</a>
      </div>
    </div>
  </div>
  <!-------------Benefits of Merchant Fold End----------------->
